<template>
  <div class="my_link_set">
    <my_input
      :titleWidth="titleWidth"
      :title="title"
      :disabled="disabled"
      :width="width"
      :placeholder="placeholder"
      :inputType="inputType"
      :rows="rows"
      :value.sync="value"
      type="one_level"
    ></my_input>
    <el-button size="small" class="setLink"  @click="set_link(link_data)">{{$t('components_my_link_index_2361')}}</el-button>
  </div>
</template>

<script>
import i18n from '../../language/index'

export default {
  name: 'my_link_set',
  props: {
    titleWidth: {
      type: String,
      default: '40'
    },
    title: {
      // 组件的标题
      type: String,
      default: i18n.t('view_contact_us_edit_107')
    },
    type: {
      // 组件的类型  one_level 一级组件 two_level 二级组件
      type: String,
      default: 'two_level'
    },
    value: {
      // 输入框的值
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '118'
    },
    inputType: {
      type: String,
      default: 'text'
    },
    rows: {
      type: Number,
      default: 1
    },
    link:{

    }
  },
  data() {
    return {
      Result: this.value,
      link_data: this.link
    };
  },
  mounted() {},
  watch: {
    Result(val) {
      this.$emit('update:value', val); //双向数据绑定
    },
    value(val) {
      this.Result = this.value;
    }
  },
  methods: {
    set_link(val) {
      this.$store.commit("set_link/set_link_edit", val);
      this.$store.commit("set_link/set_link_dialog_show", true);
    },
  }
};
</script>

<style scoped lang="scss">
.my_link_set {
  position: relative;
  .setLink {
    position: absolute;
    right: 0;
    top: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/my_link_set/index.vue